<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-if="isDuplicate" icon small color="primary" v-on="on">
        <v-icon small>
          file_copy
        </v-icon>
      </v-btn>
      <v-btn color="primary" dark v-on="on" v-else-if="!isEdit">
        <v-icon left>mdi-stethoscope</v-icon>
        New Measurement
      </v-btn>
      <v-btn v-else icon color="primary" v-on="on" small>
        <v-icon small>edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-form v-model="$v.valid" @submit.prevent="submit">
        <v-container>
          <v-row>
            <v-col sm="3" col="3">
              <v-text-field
                type="number"
                label="ICP (ppm)"
                :error-messages="icpErrors"
                v-model="$v.formdata.icp.$model"
                :prepend-icon="formdata.icpIcon"
                @input="$v.formdata.icp.$touch()"
                @blur="$v.formdata.icp.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="text"
                label="Analyte"
                :error-messages="analyteErrors"
                v-model="$v.formdata.analyte.$model"
                :prepend-icon="formdata.analyteIcon"
                @input="$v.formdata.analyte.$touch()"
                @blur="$v.formdata.analyte.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="text"
                label="Reagent"
                :error-messages="reagentErrors"
                v-model="$v.formdata.reagent.$model"
                :prepend-icon="formdata.reagentIcon"
                @input="$v.formdata.reagent.$touch()"
                @blur="$v.formdata.reagent.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="number"
                label="Moisture (ppm)"
                :error-messages="waterErrors"
                v-model="$v.formdata.ppm_water.$model"
                :prepend-icon="formdata.waterIcon"
                @input="$v.formdata.ppm_water.$touch()"
                @blur="$v.formdata.ppm_water.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="number"
                label="BET m2/g"
                :error-messages="betErrors"
                v-model="$v.formdata.bet.$model"
                :prepend-icon="formdata.betIcon"
                @input="$v.formdata.bet.$touch()"
                @blur="$v.formdata.bet.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="number"
                label="Density"
                :error-messages="densityErrors"
                v-model="$v.formdata.density.$model"
                :prepend-icon="formdata.densityIcon"
                @input="$v.formdata.density.$touch()"
                @blur="$v.formdata.density.$touch()"
              />
            </v-col>
            <v-col sm="3" col="3">
              <v-text-field
                type="text"
                label="Run"
                :error-messages="runErrors"
                v-model="$v.formdata.run.$model"
                :prepend-icon="formdata.runIcon"
                @input="$v.formdata.run.$touch()"
                @blur="$v.formdata.run.$touch()"
              />
            </v-col>
            <v-col sm="12" col="12">
              <v-text-field
                type="text"
                label="Note"
                :error-messages="noteErrors"
                v-model="$v.formdata.note.$model"
                :prepend-icon="formdata.noteIcon"
                @input="$v.formdata.note.$touch()"
                @blur="$v.formdata.note.$touch()"
              />
            </v-col>
          </v-row>
          <v-row justify="end" class="ma-2">
            <v-btn color="error" dark @click="dialog = false">
              <v-icon left>mdi-close</v-icon>
              Close
            </v-btn>
            &nbsp;
            <v-btn color="warning" dark @click="clear">
              <v-icon left>fas fa-redo</v-icon>
              Clear
            </v-btn>
            &nbsp;
            <v-btn :disabled="$v.$invalid" color="primary" @click="submit">
              <v-icon dark left>
                fas fa-save
              </v-icon>
              Save
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import { BatchMeasurement } from "../../models/Measurement";
export default {
  name: "BatchMeasurementForm",
  mixins: [validationMixin],
  validations: BatchMeasurement.validations,
  props: {
    isDuplicate: {
      type: Boolean,
      required: true,
      default: false
    },
    batchid: {
      required: true,
      type: Number
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    instance: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      formdata: new BatchMeasurement(this.instance)
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.isEdit) {
        BatchMeasurement
          .$put(this.instance.id, this.formdata.toUpdatePayload())
          .then(() => this.dialog = false)
      } else {
        this.formdata.batch_id = this.batchid;
        BatchMeasurement
          .$post(this.formdata.toCreatePayload())
          .then(() => this.clear())
      }
    },
    clear() {
      this.formdata = new BatchMeasurement();
      this.$v.$reset();
      this.dialog = false;
    }
  },
  computed: {
    icpErrors() {
      return handleErrors("formdata", "icp", this);
    },
    analyteErrors() {
      return handleErrors("formdata", "analyte", this);
    },
    reagentErrors() {
      return handleErrors("formdata", "reagent", this);
    },
    waterErrors() {
      return handleErrors("formdata", "ppm_water", this);
    },
    betErrors() {
      return handleErrors("formdata", "bet", this);
    },
    densityErrors() {
      return handleErrors("formdata", "density", this);
    },
    noteErrors() {
      return handleErrors("formdata", "note", this);
    },
    runErrors() {
      return handleErrors("formdata", "run", this);
    }
  }
};
</script>
